export default "__VITE_ASSET__Nw0kPgy2__"